// @flow

import React from 'react';

import { buildCommonComponent } from '@zapier/legacy-components';

import 'app/common/components/ContentList.scss';

const block = 'content-list';

const buildContentListComponent = buildCommonComponent(block);

export const ContentList = buildContentListComponent(null, 'ul');

type ContentListWithItemsProps = {
  items: [string],
};

export const ContentListWithItems = ({
  items,
  ...props
}: ContentListWithItemsProps) => {
  return (
    <ContentList {...props}>
      {items.map(item => (
        <li key={item}>{item}</li>
      ))}
    </ContentList>
  );
};

ContentListWithItems.defaultProps = {
  items: [],
};

export default ContentList;
